module.exports = __webpack_public_path__ + "static/media/error.a946803e.svg";